import { sendQueuedRequestsReduxAction } from 'modules/redux/actions/save'
import setReduxAction from 'modules/redux/actions/set'
import markRequestsAsNotSaving from 'modules/training/modules/network/actions/mark-requests-as-not-saving'
import {
  NETWORK_ACTION,
  NETWORK_PATH
} from 'modules/training/modules/network/constants'
import isConnectedNetworkSelector from 'modules/training/modules/network/selectors/is-connected'

function setIsConnectedNetworkAction (value) {
  return (dispatch, getState) => {
    const wasConnected = isConnectedNetworkSelector()(getState())
    dispatch(
      setReduxAction({
        type: value
          ? NETWORK_ACTION.UPDATE_IS_CONNECTED
          : NETWORK_ACTION.DELETE_IS_CONNECTED,
        payload: {
          path: NETWORK_PATH.IS_CONNECTED,
          value
        }
      })
    )

    // If we weren't connected and we are now, send queued requests
    if (!wasConnected && value) {
      dispatch(
        markRequestsAsNotSaving()
      )
      dispatch(
        sendQueuedRequestsReduxAction()
      )
    }
  }
}

export default setIsConnectedNetworkAction
